import {
  VisibilitySettingsAccessTypeEnum,
  VisibilitySettingsRestrictionTypeEnum,
  VisibilitySettingsType,
} from '@/types/schema';

import { ALL_CONTEXTUAL_GROUPS } from './consts';

export const getRestrictionConfig = (
  restrictionConfigs: VisibilitySettingsType['restrictionConfigs'],
  type: VisibilitySettingsRestrictionTypeEnum,
) =>
  restrictionConfigs?.find((restrictionConfig) => restrictionConfig.type === type) ?? {
    type,
    entityIds: [],
  };

export const getSelectedContextualGroups = (
  restrictionConfigs: VisibilitySettingsType['restrictionConfigs'],
) =>
  restrictionConfigs?.reduce((prev, curr) => {
    if (ALL_CONTEXTUAL_GROUPS.includes(curr.type)) {
      return [...prev, curr.type];
    }

    return prev;
  }, [] as VisibilitySettingsRestrictionTypeEnum[]);

export const parseVisibilitySettingsRestrictionConfig = (value: VisibilitySettingsType) => {
  const { restrictionConfigs } = value;

  const groupIds = getRestrictionConfig(
    restrictionConfigs,
    VisibilitySettingsRestrictionTypeEnum.Groups,
  ).entityIds;

  const userIds = getRestrictionConfig(
    restrictionConfigs,
    VisibilitySettingsRestrictionTypeEnum.Users,
  ).entityIds;

  const contextualGroups = getSelectedContextualGroups(restrictionConfigs);

  return {
    groupIds: groupIds ?? [],
    userIds: userIds ?? [],
    contextualGroups: contextualGroups ?? [],
  };
};

export const adaptToRestrictionConfig = (
  value?: VisibilitySettingsType,
): VisibilitySettingsType => {
  if (value) {
    return {
      ...value,
      groupIds: undefined,
      restrictionConfigs: [
        { type: VisibilitySettingsRestrictionTypeEnum.Groups, entityIds: value.groupIds },
      ],
    };
  }

  return {
    accessType: VisibilitySettingsAccessTypeEnum.Open,
    groupIds: undefined,
    restrictionConfigs: [{ type: VisibilitySettingsRestrictionTypeEnum.Groups, entityIds: [] }],
  };
};

export const adaptToGroupIds = (value: VisibilitySettingsType): VisibilitySettingsType => {
  const { restrictionConfigs } = value;
  const groupIds = getRestrictionConfig(
    restrictionConfigs,
    VisibilitySettingsRestrictionTypeEnum.Groups,
  ).entityIds;

  return { ...value, restrictionConfigs: undefined, groupIds };
};
